module.exports = __webpack_public_path__ + "img/v.825f356d.jpg";